import { ChartType } from '../types';
import { defaultNumberValidation, } from './config-types';
import { returnNotSupportedChartType } from './config-utils';
export const CHART_CUSTOMISATION_CONFIG = [
    {
        key: 'tooltip',
        type: 'section',
        label: 'Tooltip',
        labelTranslation: 'highchartCustomisation.tooltip.title',
        layoutType: 'tab',
        chartTypesNotSupported: [],
        children: [
            {
                key: 'enabled',
                type: 'toggle',
                defaultValue: true,
                selectedValue: true,
                label: 'Show/Hide',
                labelTranslation: 'highchartCustomisation.tooltip.enabled',
                chartTypesNotSupported: [],
            },
            {
                key: 'backgroundColor',
                type: 'colorpicker',
                label: 'Background color',
                labelTranslation: 'highchartCustomisation.tooltip.backgroundColor',
                chartTypesNotSupported: [],
            },
            {
                key: 'borderColor',
                type: 'colorpicker',
                label: 'Border color',
                labelTranslation: 'highchartCustomisation.tooltip.borderColor',
                chartTypesNotSupported: [],
            },
            {
                key: 'borderWidth',
                type: 'text',
                defaultValue: '1',
                label: 'Border width (px)',
                labelTranslation: 'highchartCustomisation.tooltip.borderWidth',
                inputValidation: defaultNumberValidation,
                chartTypesNotSupported: [],
            },
            {
                key: 'opacity',
                type: 'text',
                defaultValue: '100',
                inputValidation: defaultNumberValidation,
                label: 'Opacity (%)',
                labelTranslation: 'highchartCustomisation.tooltip.opacity',
                chartTypesNotSupported: [],
            },
            {
                key: 'label',
                type: 'section',
                label: 'Column name label',
                labelTranslation: 'highchartCustomisation.tooltip.label.title',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'color',
                        type: 'colorpicker',
                        label: 'Font color',
                        labelTranslation: 'highchartCustomisation.tooltip.label.color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'fontSize',
                        type: 'text',
                        defaultValue: '12',
                        inputValidation: defaultNumberValidation,
                        label: 'Font size',
                        labelTranslation: 'highchartCustomisation.tooltip.label.fontSize',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'boldFontWeight',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Bold',
                        labelTranslation: 'highchartCustomisation.tooltip.label.bold',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'underlineTextDecoration',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Underline',
                        labelTranslation: 'highchartCustomisation.tooltip.label.underline',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'italicFontStyle',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Italic',
                        labelTranslation: 'highchartCustomisation.tooltip.label.italic',
                        chartTypesNotSupported: [],
                    },
                ],
            },
            {
                key: 'value',
                type: 'section',
                label: 'Values in tooltip',
                labelTranslation: 'highchartCustomisation.tooltip.value.title',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'color',
                        type: 'colorpicker',
                        label: 'Color',
                        labelTranslation: 'highchartCustomisation.tooltip.value.color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'fontSize',
                        type: 'text',
                        defaultValue: '12',
                        inputValidation: defaultNumberValidation,
                        label: 'Size',
                        labelTranslation: 'highchartCustomisation.tooltip.value.fontSize',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'boldFontWeight',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Bold',
                        labelTranslation: 'highchartCustomisation.tooltip.value.bold',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'underlineTextDecoration',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Underline',
                        labelTranslation: 'highchartCustomisation.tooltip.value.underline',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'italicFontStyle',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Italic',
                        labelTranslation: 'highchartCustomisation.tooltip.value.italic',
                        chartTypesNotSupported: [],
                    },
                ],
            },
        ],
    },
    {
        key: 'regression',
        type: 'section',
        layoutType: 'tab',
        label: 'Regression line',
        labelTranslation: 'highchartCustomisation.regression.title',
        chartTypesNotSupported: [
            ChartType.Pie,
            ChartType.Waterfall,
            ChartType.Heatmap,
            ChartType.Treemap,
            ChartType.Funnel,
        ],
        children: [
            {
                key: 'color',
                type: 'colorpicker',
                label: 'Color',
                labelTranslation: 'highchartCustomisation.regression.color',
                chartTypesNotSupported: [],
            },
            {
                key: 'lineWidth',
                type: 'text',
                defaultValue: '2',
                inputValidation: defaultNumberValidation,
                label: 'Line width (px)',
                labelTranslation: 'highchartCustomisation.regression.lineWidth',
                chartTypesNotSupported: [],
            },
            {
                key: 'dashStyle',
                type: 'dropdown',
                values: ['Solid', 'Dot', 'Dash'],
                defaultValue: 'Solid',
                label: 'Dash style',
                labelTranslation: 'highchartCustomisation.regression.dashStyle',
                chartTypesNotSupported: [],
            },
        ],
    },
    {
        key: 'gridlines',
        type: 'section',
        label: 'Gridlines',
        labelTranslation: 'highchartCustomisation.gridlines.title',
        layoutType: 'tab',
        chartTypesNotSupported: [
            ChartType.Heatmap,
            ChartType.Treemap,
            ChartType.Funnel,
            ChartType.Pie,
        ],
        children: [
            {
                key: 'xAxis',
                type: 'section',
                label: 'X-axis gridlines',
                labelTranslation: 'highchartCustomisation.gridlines.xAxis.title',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'gridLineColor',
                        type: 'colorpicker',
                        label: 'Color',
                        labelTranslation: 'highchartCustomisation.gridlines.xAxis.color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineWidth',
                        type: 'text',
                        defaultValue: '2',
                        inputValidation: defaultNumberValidation,
                        label: 'Line width (px)',
                        labelTranslation: 'highchartCustomisation.gridlines.xAxis.lineWidth',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineDashStyle',
                        type: 'dropdown',
                        values: ['Dash', 'Dot', 'Solid'],
                        defaultValue: 'Solid',
                        label: 'Line style',
                        labelTranslation: 'highchartCustomisation.gridlines.xAxis.lineStyle',
                        chartTypesNotSupported: [],
                    },
                ],
            },
            {
                key: 'yAxis',
                type: 'section',
                label: 'Y-axis gridlines',
                labelTranslation: 'highchartCustomisation.gridlines.yAxis.title',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'gridLineColor',
                        type: 'colorpicker',
                        label: 'Color',
                        labelTranslation: 'highchartCustomisation.gridlines.yAxis.color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineWidth',
                        type: 'text',
                        defaultValue: '2',
                        inputValidation: defaultNumberValidation,
                        label: 'Line width (px)',
                        labelTranslation: 'highchartCustomisation.gridlines.yAxis.lineWidth',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineDashStyle',
                        type: 'dropdown',
                        values: ['Dash', 'Dot', 'Solid'],
                        defaultValue: 'Solid',
                        label: 'Line style',
                        labelTranslation: 'highchartCustomisation.gridlines.yAxis.lineStyle',
                        chartTypesNotSupported: [],
                    },
                ],
            },
        ],
    },
    {
        key: 'answerLevelSettings',
        type: 'section',
        label: 'Other settings',
        labelTranslation: 'highchartCustomisation.answerLevelSettings.title',
        layoutType: 'tab',
        chartTypesNotSupported: [],
        children: [
            {
                key: 'backgroundColor',
                type: 'colorpicker',
                label: 'Chart background color',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.backgroundColor',
                chartTypesNotSupported: [],
            },
            {
                key: 'plotBackgroundColor',
                type: 'colorpicker',
                label: 'Background color for plotted area',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.plotBackgroundColor',
                chartTypesNotSupported: [],
            },
            {
                key: 'plotBackgroundImage',
                type: 'text',
                label: 'Background image URL for plotted area (png file)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.plotBackgroundImage',
                chartTypesNotSupported: [],
            },
            {
                key: 'width',
                type: 'text',
                label: 'Bar width (px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.barWidth',
                inputValidation: defaultNumberValidation,
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Bar,
                        ChartType.StackedBar,
                    ]),
                ],
            },
            {
                key: 'width',
                type: 'text',
                label: 'Column width (px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.columnWidth',
                inputValidation: defaultNumberValidation,
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Column,
                        ChartType.StackedColumn,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                        ChartType.Waterfall,
                    ]),
                ],
            },
            {
                key: 'padding',
                type: 'text',
                label: 'Padding between bars (0-1 px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.paddingBars',
                inputValidation: defaultNumberValidation,
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Bar,
                        ChartType.StackedBar,
                    ]),
                ],
            },
            {
                key: 'dashStyle',
                type: 'dropdown',
                defaultValue: 'Solid',
                values: ['Solid', 'Dash', 'Dot'],
                label: 'Line type',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.lineType',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Line,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                        ChartType.Area,
                    ]),
                ],
            },
            {
                key: 'lineWidth',
                type: 'text',
                defaultValue: '',
                label: 'Line width (px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.lineWidth',
                inputValidation: defaultNumberValidation,
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Line,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                        ChartType.Area,
                    ]),
                ],
            },
            {
                key: 'markerType',
                type: 'dropdown',
                defaultValue: 'Circle',
                values: [
                    'Circle',
                    'Square',
                    'Diamond',
                    'Triangle',
                    'Triangle-down',
                ],
                label: 'Data marker type',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.markerType',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Line]),
                ],
            },
            {
                key: 'markerRadius',
                type: 'text',
                defaultValue: '',
                label: 'Data marker radius (px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.markerRadius',
                inputValidation: defaultNumberValidation,
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Scatter]),
                ],
            },
            {
                key: 'padding',
                type: 'text',
                label: 'Padding between columns (0-1 px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.paddingColumns',
                inputValidation: defaultNumberValidation,
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Column,
                        ChartType.LineColumn,
                        ChartType.StackedColumn,
                        ChartType.LineStackedColumn,
                    ]),
                ],
            },
            {
                key: 'paddingCategories',
                type: 'text',
                label: 'Padding between categories (0-1 px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.paddingCategories',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Bar,
                        ChartType.Column,
                        ChartType.StackedBar,
                        ChartType.StackedColumn,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                    ]),
                ],
            },
            {
                key: 'borderColor',
                type: 'colorpicker',
                label: 'Border color',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.borderColor',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Pie]),
                ],
            },
            {
                key: 'borderWidth',
                type: 'text',
                label: 'Border width (px)',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.borderWidth',
                defaultValue: '0',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Pie,
                        ChartType.Heatmap,
                        ChartType.Treemap,
                    ]),
                ],
            },
            {
                key: 'connectingLines',
                type: 'toggle',
                defaultValue: false,
                label: 'Turn off connecting lines',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.connectingLines',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Waterfall]),
                ],
            },
            {
                key: 'lineColor',
                type: 'text',
                label: 'Line color',
                labelTranslation: 'highchartCustomisation.answerLevelSettings.lineColor',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Pareto]),
                ],
            },
        ],
    },
];
//# sourceMappingURL=chart-advanced-customisation-config.js.map